import * as yup from 'yup'

const setNewPasswordFormValidationSchema = yup
  .object({
    password: yup.string().required('Password is required'),
    rePassword: yup
      .string()
      .required('Confirmation password is required')
      .oneOf([yup.ref('password')], `The passwords do not match`)
  })
  .required()

export default setNewPasswordFormValidationSchema
